import React from 'react';
import Input from '../../../components/ui/Input';

const CustomerDetailsForm = ({ formData, errors, onChange }) => {
  const handleInputChange = (field) => (e) => {
    onChange(field, e?.target?.value);
  };

  return (
    <div className="space-y-6">
      <div className="border-b border-border pb-4">
        <h3 className="text-lg font-semibold text-foreground mb-2">Customer Details</h3>
        <p className="text-sm text-muted-foreground">Please provide your contact information for pickup coordination</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Customer Name"
          type="text"
          placeholder="Enter your name"
          value={formData?.name}
          onChange={handleInputChange('name')}
          error={errors?.name}
          required
          className="w-full"
        />

        <Input
          label="Mobile Number"
          type="tel"
          placeholder="Enter 10-digit mobile number"
          value={formData?.mobile}
          onChange={handleInputChange('mobile')}
          error={errors?.mobile}
          required
          className="w-full"
        />
      </div>
      <Input
        label="Email Address"
        type="email"
        placeholder="Enter your email address"
        value={formData?.email}
        onChange={handleInputChange('email')}
        error={errors?.email}
        className="w-full"
      />
      <Input
        label="Pickup Address"
        type="text"
        placeholder="Enter complete address with landmark"
        value={formData?.address}
        onChange={handleInputChange('address')}
        error={errors?.address}
        description="Include apartment/house number, street name, and nearby landmark"
        className="w-full"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Pincode"
          type="text"
          placeholder="Enter 6-digit pincode"
          value={formData?.pincode}
          onChange={handleInputChange('pincode')}
          error={errors?.pincode}
          maxLength={6}
          className="w-full"
        />

        <Input
          label="Area/Locality"
          type="text"
          placeholder="Enter area name"
          value={formData?.area}
          onChange={handleInputChange('area')}
          error={errors?.area}
          className="w-full"
        />
      </div>
    </div>
  );
};

export default CustomerDetailsForm;
